import request from '@/utils/request'


// 根据字典类型查询字典数据信息
export function getDicts(dictType) {
  return request({
    url: 'data/type/' + dictType,
    method: 'get'
  })
}

// 上传文件图片
export function addider(data) {
  return request({
    url: '/common/upload/wb',
    method: 'post',
    data: data
  })
}

// 更换头像
export function setupdateHead(data) {
  return request({
    url: '/userInfo/headportrait/updateHead ',
    method: 'post',
    data: data
  })
}



// WEBPACK FOOTER //
// ./src/api/dict/data.js